import Nullstack from 'nullstack';
export default function IconArrowsDown({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-down",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "21",
    x2: "7",
    y2: "3"
  }), "   ", Nullstack.element("path", {
    d: "M20 18l-3 3l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M4 18l3 3l3 -3"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "21",
    x2: "17",
    y2: "3"
  }), " ");
}